import React from 'react';
import { Drawer } from '@cp/ds/src/components/drawer';
import loadable from '@loadable/component';
import { useDispatch, useSelector } from 'react-redux';
import { useTheme } from '@cp/ds/src/hooks/useTheme';
import { catalogLayoutFilterSecondOpenedSelector, catalogLayoutSlice } from 'src/features/catalog';
import { CatalogFilterMobileProps } from './model';

// Load content async to reduce initial loaded & rendered components count on the page
const FilterContent = loadable(() => import('./content'));

export const CatalogFilterMobile: React.FC<CatalogFilterMobileProps> = (props) => {
  const dispatch = useDispatch();
  const isOpened = useSelector(catalogLayoutFilterSecondOpenedSelector);

  const handleClose = () => dispatch(catalogLayoutSlice.actions.setFilterSecondOpened(false));

  return (
    <Drawer
      BackdropProps={{ sx: { zIndex: 3 } }}
      ModalProps={{
        components: { Root: 'div' },
      }}
      PaperProps={{ sx: { backgroundColor: 'white', zIndex: 90 } }}
      anchor="right"
      onClose={handleClose}
      open={isOpened}
      sx={{ zIndex: 90 }}
      variant="temporary"
    >
      {/* Render & load component only after filter opening */}
      {isOpened && <FilterContent {...props} onClose={handleClose} />}
    </Drawer>
  );
};
